import * as React from 'react';
import translate from '../../../../locale/translate';

export default function renderEmpty(title?: string, p?: string) {
    if(!title) {
        title = translate.gettext("No data available")
    }

    if(!p) {
        p = translate.gettext("No data available for the chosen filter criteria.");
    }

    return (
        <div className="jumbotron">
            <h1>{title}</h1>
            <p>{p}</p>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/widget/common/Render/renderEmpty.tsx